<script lang="ts" setup>
import { RequestError } from 'Api';
import BaseForm from 'Components/Base/BaseForm.vue';
import BaseFormInput from 'Components/Base/BaseFormInput.vue';
import BaseFormGroup from 'Components/Base/BaseFormGroup.vue';
import { BaseButton } from 'Components/Base/BaseButton';
import { useFormSubscribeNewsletter } from './composables/useFormSubscribeNewsletter';

const {
  FormBeforeSendError,
  isFormLoading,
  formValidation,
  formModel,
  formSend,
  formSendErrorMessage,
} = useFormSubscribeNewsletter();

async function send() {
  try {
    await formSend();
  } catch (error) {
    if (!(error instanceof FormBeforeSendError) && !(error as RequestError).handled) throw error;
  }
}

</script>

<template>
  <div class="FormSubscribeNewsletter form-subscribe-newsletter">
    <div class="is-h3__title form-subscribe-newsletter__title">
      Subscribe to The Farmland Factor Newsletter
    </div>
    <BaseForm
      v-slot="{ isFormSendLoading }"
      :send-loading="isFormLoading"
      class="form-subscribe-newsletter__form"
    >
      <div
        class="form-subscribe-newsletter__form-wrapper"
        :class="{ 'is--loading': isFormSendLoading }"
      >
        <BaseFormGroup
          class="form-subscribe-newsletter__form-group"
          :validation="formValidation.email"
          :show-error="Boolean(formSendErrorMessage)"
        >
          <template #default="{ isFieldError }">
            <BaseFormInput
              id="subscribe_email"
              v-model="formModel.data.email"
              name="email"
              label="Email"
              placeholder="Email Address"
              :disabled="isFormSendLoading"
              :is-error="isFieldError"
              class="form-subscribe-newsletter__input"
            />
          </template>
          <template #error>
            {{ formSendErrorMessage }}
          </template>
        </BaseFormGroup>
        <BaseButton
          :disabled="isFormSendLoading"
          class="form-subscribe-newsletter__button"
          type="submit"
          color="outlined-gray"
          large
          :loading="isFormSendLoading"
          @click.prevent="send"
        >
          Subscribe
        </BaseButton>
      </div>
    </BaseForm>
  </div>
</template>

<style lang="sass" scoped>
@import '~Styles/_variables'
.form-subscribe-newsletter
  &__title
    color: $mercury
    margin-bottom: 15px

  &__form
    display: flex
    flex-direction: column
    width: 100%

  &__form-wrapper
    display: flex
    &.is--loading
      opacity: .5

  &__form-group
    width: 100%

  &__input
    width: 100%

  &__button
    margin-left: 10px
</style>
